import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { updateTerminalDeliverySettings } from "services/company.service";
import { SettingRow, SettingsCard, Toggle, useSaveWithToast } from "../ui";

interface TerminalDeliveryTabProps {
  companyEntity: any;
  onRefresh: () => void;
}

export default function TerminalDeliveryTab({
  companyEntity,
  onRefresh,
}: TerminalDeliveryTabProps) {
  const { t } = useTranslation();
  const { companyId } = useParams<{ companyId: string }>();
  const { save, saving } = useSaveWithToast();
  const savedActive = Boolean(companyEntity.isTerminalDeliveryActive);
  const [isActive, setIsActive] = useState(savedActive);

  // Follows the company record when it is replaced, e.g. by another company.
  useEffect(() => {
    setIsActive(savedActive);
  }, [savedActive]);

  // A switch saves the moment it is flipped; if that fails it flips back.
  const handleChange = async (next: boolean) => {
    setIsActive(next);
    const saved = await save(async () => {
      await updateTerminalDeliverySettings(
        { isTerminalDeliveryActive: next },
        companyId
      );
      onRefresh();
    });
    if (!saved) setIsActive(!next);
  };

  const label = t("terminal_delivery_accept");

  return (
    <SettingsCard>
      <SettingRow
        label={label}
        description={t("terminal_delivery_accept_hint")}
        action={
          <Toggle
            checked={isActive}
            onChange={handleChange}
            disabled={saving}
            label={label}
          />
        }
      />
    </SettingsCard>
  );
}
